// extracted by mini-css-extract-plugin
export const bikeHeroLeftMobile = "bikeHero-module--bike-hero-left-mobile--1BiKd";
export const bikeHeroRightMobile = "bikeHero-module--bike-hero-right-mobile--1ZS20";
export const bikeHeroLeftTablet = "bikeHero-module--bike-hero-left-tablet--20B6f";
export const bikeHeroRightTablet = "bikeHero-module--bike-hero-right-tablet--3whOX";
export const bikeHeroLeftDesktop = "bikeHero-module--bike-hero-left-desktop--1ytjJ";
export const bikeHeroRightDesktop = "bikeHero-module--bike-hero-right-desktop--3qhtB";